var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphLow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Frame 152"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.00195312,
    y: 0.351562,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#FDEEF1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "arrow_drop_up"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_236_1063",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 0.00195312,
    y: 0.351562,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_236_1063)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "auto_graph",
    d: "M4.86679 7.95189C4.70022 8.11845 4.61694 8.31064 4.61694 8.52845C4.61694 8.74626 4.70022 8.93845 4.86679 9.10501L9.51772 13.7559C9.59459 13.8328 9.67787 13.8873 9.76756 13.9193C9.85725 13.9513 9.95334 13.9673 10.0558 13.9673C10.1583 13.9673 10.2544 13.9513 10.3441 13.9193C10.4338 13.8873 10.5171 13.8328 10.594 13.7559L13.1308 11.2191L18.0508 16.7541C18.1918 16.9206 18.3743 17.0039 18.5986 17.0039C18.8228 17.0039 19.0118 16.927 19.1655 16.7733C19.3064 16.6323 19.3801 16.4626 19.3865 16.264C19.3929 16.0654 19.3257 15.8892 19.1847 15.7355L13.669 9.52783C13.5921 9.43814 13.5056 9.37087 13.4095 9.32603C13.3134 9.28119 13.2141 9.25876 13.1116 9.25876C13.0091 9.25876 12.9098 9.27798 12.8137 9.31642C12.7176 9.35486 12.6311 9.41251 12.5543 9.48939L10.0558 11.9878L6.01991 7.95189C5.85335 7.78533 5.66116 7.70205 5.44335 7.70205C5.22554 7.70205 5.03335 7.78533 4.86679 7.95189Z",
    fill: "#EE324C"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphLow);
export default __webpack_public_path__ + "static/media/graph_low.2ca84f1a91b5dcd4c2da671093bb5a65.svg";
export { ForwardRef as ReactComponent };